import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
// eslint-disable-next-line no-restricted-imports
import { Separator } from 'reakit'; // eslint-disable-next-line no-restricted-imports

/**
 * Internal dependencies
 */
import { contextConnect, useContextSystem } from '../ui/context'; // eslint-disable-next-line no-duplicate-imports

import { DividerView } from './styles';

function Divider(props, forwardedRef) {
  const contextProps = useContextSystem(props, 'Divider');
  return createElement(Separator, _extends({
    as: DividerView
  }, contextProps, {
    ref: forwardedRef
  }));
}
/**
 * `Divider` is a layout component that separates groups of related content.
 *
 * @example
 * ```js
 * import {
 *     __experimentalDivider as Divider,
 *     __experimentalText as Text }
 * from `@wordpress/components`;
 *
 * function Example() {
 * 	return (
 * 		<ListGroup>
 * 			<FormGroup>...</FormGroup>
 * 			<Divider />
 * 			<FormGroup>...</FormGroup>
 * 		</ListGroup>
 * 	);
 * }
 * ```
 */


const ConnectedDivider = contextConnect(Divider, 'Divider');
export default ConnectedDivider;
//# sourceMappingURL=component.js.map